import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'

@Injectable({ providedIn: 'root' })
export class BffHttpClient {

  private request(url: string, method: string, body?: any): Observable<any> {
    return new Observable(observer => {
      const sw = navigator.serviceWorker.controller

      if (!sw) {
        observer.error({ message: 'Service Worker não está ativo. Recarregue a página.' })
        return
      }

      const channel = new MessageChannel()

      channel.port1.onmessage = (event) => {
        if (event.data?.error) {
          observer.error(event.data.error)
        } else {
          observer.next(event.data.response)
          observer.complete()
        }
      }

      sw.postMessage({
        type: 'API_REQUEST',
        url,
        method,
        body: body || null
      }, [channel.port2])
    })
  }

  get(url: string): Observable<any> {
    return this.request(url, 'GET')
  }

  post(url: string, body: any): Observable<any> {
    return this.request(url, 'POST', body)
  }

  put(url: string, body: any): Observable<any> {
    return this.request(url, 'PUT', body)
  }

  patch(url: string, body: any): Observable<any> {
    return this.request(url, 'PATCH', body)
  }

  delete(url: string): Observable<any> {
    return this.request(url, 'DELETE')
  }
}